import { Observable } from 'rxjs';

import { UseCase } from '../../base/use-case';

import {
  ContentResourceModel,
  DataContentResourceModel,
} from '../../models/academy/content-resource.model';

import { AcademyRepository } from '../../repositories/academy.repository';

export class InsertContentResourceUseCase implements UseCase<
  DataContentResourceModel,
  ContentResourceModel
> {
  constructor(private repository: AcademyRepository) {}

  execute(params: DataContentResourceModel): Observable<ContentResourceModel> {
    return this.repository.insertContentResource(params);
  }
}
